import { withDirectives, openBlock, createElementBlock, toDisplayString, vShow } from "vue";
/* empty css                     */
import _export_sfc from "../../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {
  name: "input-message",
  props: {
    message: String
  }
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return withDirectives((openBlock(), createElementBlock("div", { class: "input-message" }, toDisplayString($props.message), 513)), [
    [vShow, $props.message]
  ]);
}
const UikitInputMessage = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-9abb94bc"]]);
export {
  UikitInputMessage as default
};
//# sourceMappingURL=InputMessage.vue.es.js.map
